<template>
    <FullWidthMessage v-qa="'error-404'">
        <template #title>
            <slot name="title">
                {{ t('globals.not_found_title') }}
            </slot>
        </template>

        <template #default>
            <slot name="message">
                <p>{{ t('globals.not_found_message') }}</p>
            </slot>
            <slot name="default"></slot>
        </template>
    </FullWidthMessage>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import FullWidthMessage from '@/components/ui/FullWidthMessage.vue'

const { t } = useI18n()
</script>
